import env from './env';

export function getSiteOrigin(): string {
  const origin = env.get('VITE_SITE_ORIGIN');
  if (!origin) {
    console.warn('[SEO] VITE_SITE_ORIGIN not set, falling back to window.location.origin');
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
  return origin;
}

export function getDefaultOgImage(): string {
  return env.get('VITE_DEFAULT_OG_IMAGE_URL') || 'https://www.bookmycoaching.com/og-cover.png';
}

export function getCanonicalUrl(path: string): string {
  return `${getSiteOrigin()}${path.split('?')[0]}`;
}
